/**
 * Seat numbers for dine-in are 1-based. 0 / empty / invalid means "no seat".
 */

export function normalizeSeatNo(value) {
  if (value === null || value === undefined || value === "") return null;
  const n = typeof value === "number" ? value : parseInt(String(value).trim(), 10);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function seatDisplayName(seatNo) {
  const n = normalizeSeatNo(seatNo);
  return n ? `Seat ${n}` : "";
}

export function hasRealSeatNo(value) {
  return normalizeSeatNo(value) != null;
}
